function joinClassNames(...values) {
  return values.filter(Boolean).join(' ');
}

function normalizeTone(tone = '', variant = '') {
  const nextTone = String(tone || variant || 'info').toLowerCase();

  if (nextTone === 'danger') {
    return 'error';
  }

  return nextTone;
}

export default function Message({
  tone,
  variant,
  className = '',
  children,
  ...props
}) {
  const resolvedTone = normalizeTone(tone, variant);

  return (
    <div
      className={joinClassNames(
        'message',
        `message--${resolvedTone}`,
        'app-message',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
